import {
  Cookies,
  getCurrentDomain,
  putShopper
} from '@smuchile/pkg-unimarc-hooks'
const PRODUCT_NOTES = 'productNotes'

const getStorage = (): string => {
  if (!Cookies.get(PRODUCT_NOTES)) {
    const domain = getCurrentDomain()
    Cookies.set(PRODUCT_NOTES, '{}', { domain, path: '/' })
  }
  return Cookies.get(PRODUCT_NOTES)
}

const getNoteByProductId = (productId: string): string => {
  const notes = getStorage()
  return (Object(JSON.parse(notes))[productId] ?? '') as string
}

const addProductNote = async (productId: string, note: string) => {
  const response = (await putShopper({
    newness_type: 'substitutedata',
    data: [{ id: productId, note }]
  })) as { status?: number }

  if (response?.status === 204) {
    const notes = Object(JSON.parse(getStorage()))
    const domain = getCurrentDomain()
    Cookies.set(
      PRODUCT_NOTES,
      JSON.stringify({
        ...notes,
        [productId]: note
      }),
      { domain, path: '/' }
    )
  }
  return response
}

const removeProductNote = async (productId: string) => {
  const response = (await putShopper({
    newness_type: 'substitutedata',
    data: [{ id: productId, note: '' }]
  })) as { status?: number }

  if (response?.status === 204) {
    const jsonNotes = JSON.parse(getStorage())
    delete jsonNotes[productId]
    const domain = getCurrentDomain()
    Cookies.set(
      PRODUCT_NOTES,
      JSON.stringify({
        ...jsonNotes
      }),
      { domain, path: '/' }
    )
  }

  return response
}

export default {
  addProductNote,
  getNoteByProductId,
  getStorage,
  removeProductNote
}
